import script from "./ReportRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"

import "./ReportRegistroAsistencia.vue?vue&type=style&index=0&id=55bf5fdc&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55bf5fdc"]])

export default __exports__